import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { STATUS_COLOR_CLASS, type StatusColorTone } from '@/styles/statusColors';

interface PcmpStatusPillProps {
  tone: StatusColorTone;
  className?: string;
  children: ReactNode;
}

export function PcmpStatusPill({ tone, className, children }: PcmpStatusPillProps) {
  return (
    <span
      className={cn(
        'inline-flex w-fit items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        STATUS_COLOR_CLASS[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
